// extracted by mini-css-extract-plugin
export var button = "_o2-0";